import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import 'rodal/lib/rodal.css';

import {
  getServerUrl,
} from './constants';

import {
  getAuthTokenFromStorage,
  getUserIdFromStorage,
} from './utils';

import {
  getAllElections,
  getAllFlaggedLinks,
  getAllNationalTopics,
  getAllVoterTurnoutData,
  getUserFromStorage,
  fetchAllRoles,
} from './state/actions';

import {
  AddedCandidates,
  AddedElections,
  AddedRaces,
  Admin,
  Candidate,
  CompareCandidates,
  ElectionInfo,
  Elections,
  FlaggedLinks,
  FlaggedTopics,
  Home,
  Login,
  MyElections,
  NationalTopics,
  NewCandidate,
  NewElection,
  NewRace,
  Profile,
  Quiz,
  Race,
  Results,
  Roles,
  SignUp,
  Topics,
  Turnout,
} from './screens';

import {
  FallBack,
  NavBar,
  ScrollToTop,
  RequireAdminAuth,
} from './components';

import useGoogleAnalytics from './components/analytics';

const Routes = () => {
  useGoogleAnalytics();

  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/admin/added-candidates" component={props => <RequireAdminAuth><AddedCandidates {...props} /></RequireAdminAuth>} />
      <Route path="/admin/added-elections" component={props => <RequireAdminAuth><AddedElections {...props} /></RequireAdminAuth>} />
      <Route path="/admin/added-races" component={props => <RequireAdminAuth><AddedRaces {...props} /></RequireAdminAuth>} />
      <Route path="/admin/flagged-links" component={props => <RequireAdminAuth><FlaggedLinks {...props} /></RequireAdminAuth>} />
      <Route path="/admin/flagged-topics" component={props => <RequireAdminAuth><FlaggedTopics {...props} /></RequireAdminAuth>} />
      <Route path="/admin/national-topics" component={props => <RequireAdminAuth><NationalTopics {...props} /></RequireAdminAuth>} />
      <Route path="/admin" component={props => <RequireAdminAuth><Admin {...props} /></RequireAdminAuth>} />
      <Route path="/candidate/new" component={NewCandidate} />
      <Route path="/candidate/:id" component={Candidate} />
      <Route path="/compare-candidates/:id" component={CompareCandidates} />
      <Route path="/elections/new" component={NewElection} />
      <Route path="/elections/:id" component={ElectionInfo} />
      <Route path="/elections" component={Elections} />
      <Route path="/login" component={Login} />
      <Route path="/my-elections" component={MyElections} />
      <Route path="/profile" component={Profile} />
      <Route path="/quiz/results" component={Results} />
      <Route path="/quiz/:id" component={Quiz} />
      <Route path="/quiz" component={Quiz} />
      <Route path="/race/new" component={NewRace} />
      <Route path="/race/:id" component={Race} />
      <Route path="/roles/:id" component={Roles} />
      <Route path="/roles" component={Roles} />
      <Route path="/sign-up" component={SignUp} />
      <Route path="/topics" component={Topics} />
      <Route path="/turnout/:stateId" component={Turnout} />
      <Route path="/turnout" component={Turnout} />
      <Route component={FallBack} />
    </Switch>
  );
};

const App = (props) => {
  useEffect(() => {
    global.API_URL = getServerUrl();

    // fetch user data if persist in browser
    if (getAuthTokenFromStorage() && getUserIdFromStorage()) props.getUserFromStorage();

    // fetch all necessary initial data
    props.getAllElections();
    props.getAllNationalTopics();
    props.getAllVoterTurnoutData();
    props.fetchAllRoles();
    props.getAllFlaggedLinks();
  }, []);

  return (
    <Router>
      <ScrollToTop>
        <NavBar />
        <div className="content">
          <Routes />
        </div>
      </ScrollToTop>
    </Router>
  );
};

const mapDispatchToProps = {
  getAllElections,
  getAllFlaggedLinks,
  getAllNationalTopics,
  getAllVoterTurnoutData,
  getUserFromStorage,
  fetchAllRoles,
};

export default connect(null, mapDispatchToProps)(App);
